"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEventEndDateProperty = exports.eventEndDatePropertyDefinition = void 0;
exports.eventEndDatePropertyDefinition = {
    name: 'event-end-date',
    type: 'date-time',
    constraints: [
        {
            name: 'required',
            argument: true,
        },
    ],
    multiple: false,
    view: { label: 'Event end date' },
};
const isEventEndDateProperty = (prop) => {
    return prop.name === exports.eventEndDatePropertyDefinition.name;
};
exports.isEventEndDateProperty = isEventEndDateProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZXZlbnQtZW5kLWRhdGUucHJvcGVydHkuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvcHJvcGVydGllcy9ldmVudC1lbmQtZGF0ZS5wcm9wZXJ0eS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFFYSxRQUFBLDhCQUE4QixHQUFHO0lBQzVDLElBQUksRUFBRSxnQkFBZ0I7SUFDdEIsSUFBSSxFQUFFLFdBQVc7SUFDakIsV0FBVyxFQUFFO1FBQ1g7WUFDRSxJQUFJLEVBQUUsVUFBVTtZQUNoQixRQUFRLEVBQUUsSUFBSTtTQUNmO0tBQ0Y7SUFDRCxRQUFRLEVBQUUsS0FBSztJQUNmLElBQUksRUFBRSxFQUFFLEtBQUssRUFBRSxnQkFBZ0IsRUFBRTtDQUNGLENBQUE7QUFJMUIsTUFBTSxzQkFBc0IsR0FBRyxDQUFDLElBQWtCLEVBQWdDLEVBQUU7SUFDekYsT0FBTyxJQUFJLENBQUMsSUFBSSxLQUFLLHNDQUE4QixDQUFDLElBQUksQ0FBQTtBQUMxRCxDQUFDLENBQUE7QUFGWSxRQUFBLHNCQUFzQiwwQkFFbEMifQ==